module.exports = __webpack_public_path__ + "media/images/flags/64/Greece-ef9d5d5541692c5d8b847712513095cc.png";